/**
 * The "Away" chip (desk-and-away-contract.md §6): next to an away person in the people pickers,
 * the team members list, the Users list, and beside the signed-in person's avatar. Neutral, like
 * the Users list's "Coordinator" chip; the tooltip says since when.
 */

import type { ReactElement } from 'react'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import { awayChipTitle } from './away'

export function AwayChip({ since, className }: { since?: string | null; className?: string }): ReactElement {
  return (
    <Badge
      variant="outline"
      title={awayChipTitle(since)}
      className={cn('px-1.5 py-0 text-[10px] font-medium text-muted-foreground', className)}
      data-away-chip=""
    >
      Away
    </Badge>
  )
}
